import clsx from "clsx";
import bankingTemplateImage from "@/assets/images/template-banking.png";
import executiveTemplateImage from "@/assets/images/template-management.png";
import studentTemplateImage from "@/assets/images/template-student.png";
import { Button } from "@/components/Button/Button";
import Chip from "@/components/Chip/Chip";
import { AppText } from "@/components/Text/AppText";
import { templates } from "@/pages/LivePreview/constants";

interface LivePreviewNavigationProps {
    activeTemplateId: string | null;
    setActiveTemplateId: (id: string | null) => void;
}

export const LivePreviewNavigation = ({
    activeTemplateId,
    setActiveTemplateId,
}: LivePreviewNavigationProps) => {
    return (
        <div className="flex h-full flex-col pb-6">
            <div className="no-scrollbar flex-1 space-y-4 overflow-y-auto pt-4">
                {templates.map(template => (
                    <button
                        key={template.id}
                        className={clsx(
                            "group relative flex w-full flex-col gap-2 hover:border-primary-600",
                        )}
                        onClick={() => setActiveTemplateId(template.id)}
                    >
                        <div
                            className={clsx(
                                "relative w-full overflow-hidden rounded-md border-2 border-neutral-200",
                                template.id === activeTemplateId &&
                                    "border-primary-600 bg-primary-50",
                            )}
                        >
                            {template.imageName === "template-banking.png" && (
                                <img
                                    src={bankingTemplateImage}
                                    alt={template.name}
                                    className={clsx(
                                        "h-full w-full object-cover ",
                                        template.id === activeTemplateId &&
                                            "brightness-50",
                                    )}
                                />
                            )}
                            {template.imageName ===
                                "template-management.png" && (
                                <img
                                    src={executiveTemplateImage}
                                    alt={template.name}
                                    className={clsx(
                                        "h-full w-full object-cover ",
                                        template.id === activeTemplateId &&
                                            "brightness-50",
                                    )}
                                />
                            )}
                            {template.imageName === "template-student.png" && (
                                <img
                                    src={studentTemplateImage}
                                    alt={template.name}
                                    className={clsx(
                                        "h-full w-full object-cover ",
                                        template.id === activeTemplateId &&
                                            "brightness-50",
                                    )}
                                />
                            )}
                            {template.id === activeTemplateId && (
                                <Button className="!absolute bottom-0 left-0 right-0 top-[40%] mx-6">
                                    Selected
                                </Button>
                            )}
                            <div className="absolute bottom-0 left-0 right-0 min-h-10 border-t-2 border-neutral-200 bg-white px-4 py-2">
                                <div className="mb-1 flex items-center">
                                    <AppText
                                        variant="contextheading"
                                        className="text-neutral-900"
                                    >
                                        {template.name}
                                    </AppText>
                                </div>
                                <div className="flex min-h-[26px] flex-wrap gap-1">
                                    {template.categories.map(category => (
                                        <Chip
                                            key={category}
                                            type="secondary"
                                        >
                                            <AppText
                                                variant="footnote"
                                                className="!font-medium"
                                            >
                                                {category}
                                            </AppText>
                                        </Chip>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};
